<template>
  <div class="page-wrapper bg-red font-robo">
    <div class="wrapper wrapper--w960">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  beforeCreate () {
    if (localStorage.locale) this.$i18n.locale = localStorage.locale
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/default.vue